<div class="recent-activity-list">
  @for (row of rows(); track row.item.source_id) {
    @let item = row.item;
    <button type="button" class="recent-activity-item" [disabled]="row.disabled" (click)="onActivityClick(item)">
      <div class="recent-activity-item__icon" aria-hidden="true">
        <img [src]="iconByCategory[item.category]" alt="" />
      </div>
      <div class="recent-activity-item__content">
        <span class="recent-activity-item__title">{{ item.title }}</span>
        <span class="recent-activity-item__date">{{ item.date + 'T00:00:00' | date: 'dd MMM yy' }}</span>
      </div>
      @if (!row.disabled) {
        <div class="recent-activity-item__chevron" aria-hidden="true">
          <img [src]="chevronIcon" alt="" />
        </div>
      }
    </button>
  }
</div>
